import auth from "./endpoints/auth";
import booking from "./endpoints/booking";

const allEndpoints = {
  auth,
  booking,
};

export default allEndpoints;
